module.exports = __webpack_public_path__ + "img/rawpixel-440239-490x340.170adddc.jpg";